import { HisInformationItem } from "./HisInformationItem";

export class HisInformationListItem {
  constructor(public items: HisInformationItem[], public invisibleItems: HisInformationItem[]) {}
}
